import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'

import LeftNavMenu from 'components/LeftNavMenu'
import AttachmentOverlay from 'components/AttachmentOverlay'
import RightPanel from 'components/RightPanel/'
import OwnersList from './OwnersList'
import ActionBar from './ActionBar'
import OwnerForm from '../ownerForm'

import actionBarActions from 'actions/actionbar'
import taskFiltersActions from 'actions/taskFilters'
import rightStackActions from 'actions/rightStackActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import dataActions from 'actions/dataActions'
import Error from 'components/Error'
import loginActions from 'actions/login'

import { owners } from 'selectors/entities'
import { ownerProperties } from 'selectors/owner'

let select = (state) => ({
    ...state,
    owners: owners(state)
  })
export class Tasks extends Component {
	render() {
		try{
			return(
				<OwnersList
					owners={this.props.owners}
					openPanel={this.props.OPEN_PANEL}
					filtersIsOpened={this.props.actionBarReducers.rightNav}
					rightStackOpened={!!this.props.routeParams.id}
					navPanelIsOpened={this.props.actionBarReducers.leftNav}
					lastInteracted={(this.props.routeParams.id)?
						this.props.routeParams.id
						: ''
					}
				/>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([actionBarActions, taskFiltersActions, loginActions, rightStackActions, attachmentOverlayActions, dataActions]))(Tasks)



// WEBPACK FOOTER //
// ./src/routes/manager/owners/index.js